<template>
  <div class="form">
    <h3>{{ customer ? $t('advanced.customers.add.title_update') : $t('advanced.customers.add.title_new') }}</h3>

    <input v-model="form.name" :placeholder="$t('advanced.customers.add.name_placeholder')">
    <p v-if="!form.name && triedSubmit" class="error">{{ $t('advanced.customers.add.name_required') }}</p>

    <input v-model="form.email" :placeholder="$t('advanced.customers.add.email_placeholder')">
    <input v-model="form.phone" :placeholder="$t('advanced.customers.add.phone_placeholder')">
    <textarea v-model="form.notes" :placeholder="$t('advanced.customers.add.notes_placeholder')"></textarea>

    <div class="actions">
      <button class="primary" @click="submit">{{ customer ? $t('advanced.customers.add.update') : $t('advanced.customers.add.add') }}</button>
      <button @click="$emit('close')">{{ $t('advanced.customers.add.cancel') }}</button>
    </div>

    <p v-if="error" class="error">{{ error }}</p>
  </div>
</template>

<script>
import { ref } from "vue";
import { useI18n } from "vue-i18n";
import axios from "axios";

export default {
  props: { customer: Object },
  setup(props, { emit }) {
    const { t } = useI18n();
    const form = ref(props.customer
      ? { ...props.customer }
      : { name: "", email: "", phone: "", notes: "" }
    );

    const error = ref(null);
    const triedSubmit = ref(false);

    const submit = async () => {
      triedSubmit.value = true;

      if (!form.value.name || form.value.name.trim() === "") {
        return;
      }

      try {
        if (props.customer) {
          await axios.put(`/promo/user/my-customers/${props.customer.id}`, form.value);
        } else {
          await axios.post("/promo/user/my-customers", form.value);
        }
        emit("refresh");
        emit("close");
      } catch {
        error.value = t("advanced.customers.add.generic_error");
      }
    };

    return { form, submit, error, triedSubmit };
  }
};
</script>

<style scoped>
.form {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding-bottom: 32px;
}

input,
textarea {
  width: 100%;
}

.actions {
  display: flex;
  gap: 8px;
}

.primary {
  background: #106E35;
  border: none;
  padding: 8px 16px;
  cursor: pointer;
  color: #fff;
}

.error {
  color: #f44336;
  font-size: 1em;
}
</style>
